// Entry point for the build script in your package.json

// Hotwire Turbo
import "@hotwired/turbo-rails"

// Hotwire Stimulus
import { Application } from "@hotwired/stimulus"
const application = Application.start()
application.debug = false
window.Stimulus = application

// Stimulus Controllers
import SectionSettingsController from "./controllers/section_settings_controller"
import CookieConsentController from "./controllers/cookie_consent_controller"
import DropdownController from "./controllers/dropdown_controller"
import AnimateController from "./controllers/animate_controller"
import GalleryController from "./controllers/gallery_controller"
import ContactModalController from "./controllers/contact_modal_controller"
import ContactFormController from "./controllers/contact_form_controller"
import AccordionTabsController from "./controllers/accordion_tabs_controller"
import FlashController from "./controllers/flash_controller"
import LoginModalController from "./controllers/login_modal_controller"
import ParallaxController from "./controllers/parallax_controller"
import TabsController from "./controllers/tabs_controller"
import ScrollArrowController from "./controllers/scroll_arrow_controller"
import TypedTextController from "./controllers/typed_text_controller"
import CubeTeaserController from "./controllers/cube_teaser_controller"
import WaveTextController from "./controllers/wave_text_controller"
import ThreeFlyinController from "./controllers/three_flyin_controller"
import VortexImagesController from "./controllers/vortex_images_controller"
import SideDecoController from "./controllers/side_deco_controller"
import FeatureFilterController from "./controllers/feature_filter_controller"
import SkillWheelController from "./controllers/skill_wheel_controller"
import MobileMenuController from "./controllers/mobile_menu_controller"
import HeroSlidesController from "./controllers/hero_slides_controller"
import BlogScrollController from "./controllers/blog_scroll_controller"
import KompendiumTreeController from "./controllers/kompendium_tree_controller"
import KompendiumNavController from "./controllers/kompendium_nav_controller"
import KapriTreeController from "./controllers/kapri_tree_controller"
import KapriNavController from "./controllers/kapri_nav_controller"
import GlossarySearchController from "./controllers/glossary_search_controller"
import NewsletterFormController from "./controllers/newsletter_form_controller"
application.register("section-settings", SectionSettingsController)
application.register("cookie-consent", CookieConsentController)
application.register("dropdown", DropdownController)
application.register("animate", AnimateController)
application.register("gallery", GalleryController)
application.register("contact-modal", ContactModalController)
application.register("contact-form", ContactFormController)
application.register("accordion-tabs", AccordionTabsController)
application.register("flash", FlashController)
application.register("login-modal", LoginModalController)
application.register("parallax", ParallaxController)
application.register("tabs", TabsController)
application.register("scroll-arrow", ScrollArrowController)
application.register("typed-text", TypedTextController)
application.register("cube-teaser", CubeTeaserController)
application.register("wave-text", WaveTextController)
application.register("three-flyin", ThreeFlyinController)
application.register("vortex-images", VortexImagesController)
application.register("side-deco", SideDecoController)
application.register("feature-filter", FeatureFilterController)
application.register("skill-wheel", SkillWheelController)
application.register("mobile-menu", MobileMenuController)
application.register("hero-slides", HeroSlidesController)
application.register("blog-scroll", BlogScrollController)
application.register("kompendium-tree", KompendiumTreeController)
application.register("kompendium-nav", KompendiumNavController)
application.register("kapri-tree", KapriTreeController)
application.register("kapri-nav", KapriNavController)
application.register("glossary-search", GlossarySearchController)
application.register("newsletter-form", NewsletterFormController)




document.addEventListener("click", (e) => {
  const link = e.target.closest('a[href^="#"]')
  if (!link) return
  const id = link.getAttribute("href").slice(1)
  if (!id) return
  const target = document.getElementById(id)
  if (!target) return
  e.preventDefault()
  const navHeight = document.querySelector("header")?.offsetHeight || 70
  window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - navHeight, behavior: "smooth" })
})

document.addEventListener("turbo:frame-load", (event) => {
  if (event.target.id === "skill_detail") {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
})

// ActionText / Trix Editor
import "trix"
import "@rails/actiontext"

// Trix: <p> statt <div> für Absätze verwenden
Trix.config.blockAttributes.default.tagName = "p"

// Trix Bug-Fix: Für plain-paragraph-Blöcke (keine Block-Attribute) gibt
// shouldInsertBlockBreak() immer false zurück, weil breaksOnReturn() undefined
// liefert (default-Block hat kein breakOnReturn:true in der config).
// Fix: insertParagraph für plain Blöcke direkt mit insertBlockBreak() behandeln.
document.addEventListener("beforeinput", (evt) => {
  if (evt.inputType !== "insertParagraph") return
  if (evt.target.tagName !== "TRIX-EDITOR") return

  const editor = evt.target.editor
  const range = editor.getSelectedRange()
  if (range[0] !== range[1]) return

  try {
    const doc = editor.getDocument()
    const location = doc.locationFromPosition(range[0])
    const block = doc.getBlockAtIndex(location.index)
    // Nur für plain Blöcke (keine Block-Attribute wie heading1, bullet, quote…)
    // Blöcke mit Attributen lässt Trix selbst korrekt behandeln.
    if (!block || block.hasAttributes()) return

    evt.preventDefault()
    evt.stopPropagation()
    editor.composition.insertBlockBreak()
  } catch (e) {
    // Fehler: Trix normal weitermachen lassen
  }
}, true)

// Trix: Fix für Browser die bei Enter insertLineBreak statt insertParagraph feuern.
// Mit _trixShiftHeld-Guard: Shift+Enter soll weiterhin <br> erzeugen.
let _trixShiftHeld = false
document.addEventListener("keydown", e => { if (e.key === "Shift") _trixShiftHeld = true }, true)
document.addEventListener("keyup",   e => { if (e.key === "Shift") _trixShiftHeld = false }, true)

document.addEventListener("trix-initialize", (e) => {
  const editorEl = e.target
  let processingFix = false

  document.addEventListener("beforeinput", (evt) => {
    if (processingFix || _trixShiftHeld || evt.inputType !== "insertLineBreak") return
    if (evt.target !== editorEl) return
    evt.preventDefault()
    evt.stopPropagation()
    processingFix = true
    editorEl.dispatchEvent(new InputEvent("beforeinput", {
      inputType: "insertParagraph",
      bubbles: true,
      cancelable: true
    }))
    processingFix = false
  }, true)
})

// Trix: Farbpalette für Textauszeichnung
const TRIX_COLORS = [
  { key: "colorBlue",   hex: "#3b82f6", label: "Blau" },
  { key: "colorRed",    hex: "#ef4444", label: "Rot" },
  { key: "colorGreen",  hex: "#22c55e", label: "Grün" },
  { key: "colorOrange", hex: "#fdb700", label: "Orange" },
  { key: "colorPurple", hex: "#a855f7", label: "Lila" },
  { key: "colorGray",   hex: "#cbd5e1", label: "Gray" },
]

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgb(${r}, ${g}, ${b})`
}

TRIX_COLORS.forEach(({ key, hex }) => {
  Trix.config.textAttributes[key] = {
    style: { color: hex },
    inheritable: true,
    parser: el => el.style.color === hex || el.style.color === hexToRgb(hex)
  }
})

document.addEventListener("trix-initialize", (e) => {
  const toolbar = e.target.toolbarElement

  // Fix href input für relative URLs
  const input = toolbar?.querySelector("input[name=href]")
  if (input) {
    input.type = "text"
    input.placeholder = "URL oder /pfad#anchor"
  }

  // Farb-Buttons einfügen
  const buttonGroups = toolbar?.querySelector(".trix-button-row")
  if (!buttonGroups) return

  const group = document.createElement("span")
  group.className = "trix-button-group trix-button-group--color-tools"

  TRIX_COLORS.forEach(({ key, hex, label }) => {
    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "trix-button"
    btn.setAttribute("data-trix-attribute", key)
    btn.title = label
    btn.innerHTML = `<span style="color:${hex};font-weight:700;font-family:serif;font-size:1.1em;line-height:1;">A</span>`
    group.appendChild(btn)
  })

  // "Farbe entfernen"-Button
  const removeBtn = document.createElement("button")
  removeBtn.type = "button"
  removeBtn.className = "trix-button"
  removeBtn.title = "Farbe entfernen"
  removeBtn.style.cssText = "font-size:0.7em;letter-spacing:-0.05em;"
  removeBtn.textContent = "A×"
  removeBtn.addEventListener("click", () => {
    const editor = e.target.editor
    TRIX_COLORS.forEach(({ key }) => editor.deactivateAttribute(key))
  })
  group.appendChild(removeBtn)

  buttonGroups.appendChild(group)
})

// Trix: Bild-Einfügen setzt Block-Format auf normal zurück
document.addEventListener("trix-attachment-add", (e) => {
  const attachment = e.attachment
  if (!attachment.file && !attachment.getAttribute("content-type")?.startsWith("image/")) return
  const editor = e.target.editor
  requestAnimationFrame(() => {
    ["heading1"].forEach(attr => {
      if (editor.attributeIsActive(attr)) editor.deactivateAttribute(attr)
    })
  })
})
